import { create } from 'zustand';

export interface RegistrationStore {
  steps: number;
  activeStep: number;
  setSteps: (steps: number) => void;
  setActiveStep: (step: number) => void;
}

const initialState = {
  steps: 3,
  activeStep: 1,
};

export const useRegistrationStore = create<RegistrationStore>()((set) => ({
  ...initialState,
  setSteps: (steps) => set(() => ({ steps: steps })),
  setActiveStep: (step) => set(() => ({ activeStep: step })),
}));
